import html2pdf from 'html2pdf.js';

/**
 * Format a string to be used as a filename (remove umlauts, spaces, and special characters)
 * @param {string} str - The string to format
 * @returns {string} The formatted string
 */
const formatFilename = (str) => {
  if (!str) return '';

  // Replace umlauts
  let formatted = str
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/Ä/g, 'Ae')
    .replace(/Ö/g, 'Oe')
    .replace(/Ü/g, 'Ue')
    .replace(/ß/g, 'ss');

  // Replace spaces and special characters
  formatted = formatted
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '');

  return formatted;
};

/**
 * Generate a PDF from the artifact content
 * @param {Object} params - Parameters for PDF generation
 * @param {string} params.documentTitle - Title of the document
 * @returns {Function} Function to handle PDF generation
 */
const generatePdf = ({ documentTitle }) => {
  return () => {
    // Get the artifact element
    const element = document.querySelector('.apple-doc');

    if (!element) {
      console.error('Artifact element not found');
      alert('Fehler: Dokument-Element konnte nicht gefunden werden.');
      return;
    }

    // Format the document title for the filename
    const formattedName = formatFilename(documentTitle || "Führungsdokument");
    const filename = `summary-${formattedName}.pdf`;


    // Define PDF options
    const opt = {
      margin: [10, 10, 10, 10],
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        letterRendering: true,
        logging: true // Enable logging for debugging
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait'
      }
    };

    // Generate PDF directly from the element
    html2pdf().from(element).set(opt).save()
      .then(() => {
        console.log('PDF generated successfully');
      })
      .catch(error => {
        console.error('Error generating PDF:', error);
        alert(`Fehler beim Erstellen des PDFs: ${error.message || 'Unbekannter Fehler'}`);
      });
  };
};

export default generatePdf;
